<template>
  <ul
      class="nav p-2 flex-nowrap overflow-x-auto flex-md-column w-100 h-100"
  >

    <li
        v-if="displayOpen"
        class="nav-item d-none d-md-flex px-1 py-md-1"
    >
      <span
        class="nav-link text-secondary border-bottom border-secondary w-100"
      >
        {{$t('admin.main_title')}}
      </span>
    </li>

    <li
        v-for="item in menu" :key="item"
        class="nav-item px-1 py-md-1 text-nowrap"
    >
        <router-link
            :to="'/' + item.slug + '/' + ((item.je_dashboard == '1')? 'dashboard':'list')+ '/'"
            activeClass="is-exact-link"
            :class="'nav-link link-secondary' + ($route.path.includes('/' + item.slug + '/')? ' --bg-danger active': '')"
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :title="item.title"
        >
          <i
              v-if="item.ico_class"
              :class="'bi '+item.ico_class"
          ></i>&nbsp;
          <span
            v-if="displayOpen"
            class="d-none d-md-inline"
          >
            {{item.title}}
          </span>
        </router-link>
    </li>

    <li class="flex-md-grow-1"></li>

    <li
        v-if="user.is_notification"
        class="-nav-item p-1 order-first order-md-0"
    >
      <!-- && isNotificationDisplay -->
      <div
          class="d-flex"
      >
        <router-link
            v-show="notificationPath"
            :to="notificationPath"
            class="d-block bg-secondary-subtle text-secondary ratio-1x1 rounded rounded-pill py-1 px-2 position-relative"
        >
          <i class="bi bi-bell"></i>
          <span
              v-show="notificationCount > 0"
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            <!--
             {{notificationCount}}
            -->
            <div
                ref="notificationCountElement"
                class="d-flex ratio ratio-1x1
                p-0 d-flex justify-content-center align-items-center"
                style="width: 1rem; "
            >

            </div>
            <span class="visually-hidden">unread messages</span>
          </span>
        </router-link>
      </div>
    </li>

    <!--
    <li
        class="nav-item px-1 py-1 text-nowrap d-none d-md-block"
    >

      <div
          ref="__notificationCountElement"
          class="d-flex ratio ratio-1x1
          p-0 d-flex justify-content-center align-items-center"
          style="width: 30px; "
      >
        x ({{notificationCount}})
      </div>


      [dev]
      <span @click="notificationCount=2">2</span>/
      <span @click="notificationCount=3">3</span>/
      <span @click="notificationCount=7">7</span>/
      <span @click="notificationCount=11">11</span>
    </li>
    -->
    <li
        class="nav-item px-1 py-1 text-nowrap d-none d-md-block"
    >
      <div
          class="d-flex"
      >
        <div
            @click.prevent="displayOpen = !displayOpen"
            class="d-block bg-secondary-subtle text-secondary ratio-1x1 rounded rounded-pill py-1 px-2 position-relative pseudo-link"
        >
          <i
              v-if="displayOpen"
              class="bi bi-arrows-collapse-vertical link-secondary"
          />
          <i
              v-else
              class="bi bi-arrows-expand-vertical link-secondary"
          />
        </div>
      </div>
    </li>

    <li
        class="nav-item px-1 py-1 text-nowrap"
    >
      <div
          class="d-flex"
      >
        <div
            class="d-block bg-warning text-secondary ratio-1x1 rounded rounded-pill py-1 px-3 position-relative fw-bold"
        >
          <div
              v-if="user.obrazek_id"
              class="-border border-success"
              :title="user.title"
          >
            <image-component
                :image-id="user.obrazek_id"
                :is_preview_only="true"
                thumb_class="menu-user-thumb rounded-circle"
            />
          </div>
          <small
            v-else
          >
            {{user.short_title}}</small>

          <router-link
              to="/user-manager/settings"
              :title="$t('layout.menu.user.hint')"
              class="link-secondary text-decoration-none"
          >
            <i class="bi bi-gear link-secondary ms-2"/>
          </router-link>
        </div>

      </div>
    </li>

    <li
        class="nav-item px-md-1 py-1 text-nowrap"
    >
      <div
          @click.prevent="logout"
          class="d-flex bg-primary-subtle rounded-pill px-2 px-md-4 py-1 py-md-2 link-secondary text-decoration-none pseudo-link"
      >
        <div
            class=""
        >
          <i class="bi bi-power link-secondary"></i>
        </div>
        <div
            v-if="displayOpen"
            class="-border border-success ms-2 flex-md-grow-1 text-center d-none d-md-block"
        >
          {{$t('layout.logout.title')}}
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import axios from "axios";
import ImageComponent from "@/components/general/Image";
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import DisplayDebug from "@/components/general/DisplayDebug.vue";
const lsMenuDisplay = 'menu_display';
import gsap from "gsap";

export default {
  name: "MainMenu",
  components:{
    gsap,
    DisplayDebug,
    ImageComponent,

  },
  props: {
    user: Object
  },
  data() {
    return {
      menu: [],
      displayOpen: null,
      window: null,
      isNotificationDisplay: false,
      notificationCount: 0,
      notificationPath: '/push-notification/unread-notification'
    }
  },
  methods: {
    async logout() {
      if (confirm("Opravdu se chcete odhlásit z administrace?") === true){

        axios.defaults.baseURL = this.getBaseRoot();
        await axios({
          //url: this.cfg.api.user.logout_path,
          //method: "post",
          url: this.getApiConfig('user.logout.path'),
          method: this.getApiConfig('user.logout.method'),

          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          if(res.data) {
            this.$router.push('/?path=' + this.$route.path)
          }else{
            //this.loginStatus = false;
            //console.log("DEV RES NODATA", res.data);
          }
        });
      }
    },
    async getMenu(){
      axios.defaults.baseURL = this.getBaseRoot();
        await axios({
          //url: this.cfg.api.general.main_menu_path,
          //method: "get",
          url: this.getApiConfig('general.main_menu.path'),
          method: this.getApiConfig('general.main_menu.method'),

          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          if(res.data) {
            if(res.data.response.menu) {
              this.menu = res.data.response.menu;
            }
          }else{
            //this.loginStatus = false;
            //console.log("DEV RES NODATA", res.data);
          }
        });
    },
    async getNotificationCount(){
      if(
          this.user.is_notification
      ) {
        axios.defaults.baseURL = this.getBaseRoot();
        await axios({
          url: this.getApiConfig('notification.unread_count.path'),
          method: this.getApiConfig('notification.unread_count.method'),
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          if(res.data) {
            //this.notificationPath = res.data.response.path;
            if(
                typeof res.data.response.count != 'undefined' &&
                res.data.response.count > 0
            ) {
              this.notificationCount = res.data.response.count;
              this.isNotificationDisplay = true;
            }else{
              this.notificationCount = null;
              this.isNotificationDisplay = false;
            }
          }
        });
      }
    },
    notificationCountAnimate(newValue, oldValue = 0) {
      const el = this.$refs.notificationCountElement;
      if (!el) return;

      const tl = gsap.timeline();

      tl.to(el, {
        rotate: 360,
        duration: 0.6,
        ease: "power2.inOut",
        // onUpdate běží během celé animace,
        // onStart běží hned, jak se začne točit
        onStart: () => {
          el.innerText = oldValue;
        },
        // Použijeme label nebo delay pro změnu textu v polovině otočky
      })
          // Přidáme změnu textu přesně v polovině animace (0.3s)
          .set(el, { innerText: newValue }, 0.3)
          // Resetujeme rotaci na 0 bez animace na konci, aby byl prvek připraven na příště
          .set(el, { rotate: 0 });
    },
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar],
    };
  },

  watch: {
    'notificationCount': {
      handler(newVal, oldVal) {
        //console.log('MM DEV notificationCount WATCH', newVal, oldVal)
        this.notificationCountAnimate(newVal, oldVal);
      }
    },
    '$push': {
      handler(newVal, oldVal) {
        console.log('DEV prijeti PUSH- MIAN MENU', newVal, oldVal)
        if(
            newVal
            && typeof newVal.data != 'undefined'
            && newVal.data
        ) {
          //console.log('DEV prijeti PUSH notifikace v MIAN MENU')
          this.getNotificationCount();

          /*
          this.notifications.unshift(
              {
                'body': newVal.data.notification.body,
                'title': newVal.data.notification.title,
                'params': newVal.data.data,
              }
          )*/
        }
      },
      deep: true,
      immediate: true
    },
    displayOpen: {
      handler(newVal) {
        if(newVal !== null) {
          localStorage.setItem(
              lsMenuDisplay,
              newVal? 1: 0
          )
        }
      },
      immediate: true
    },
  },
  created() {
    this.getMenu();
    this.window = this.getDeviceViewport();

    window.addEventListener('resize',() => {
      this.window = this.getDeviceViewport();
    });
  },
  mounted() {
    if(localStorage.getItem(lsMenuDisplay) == 0) {
      this.displayOpen = false;
    }else{
      this.displayOpen = true;
    }

    setTimeout(() => {
      this.getNotificationCount();
    }, 600);

    setInterval(
() => {
        this.getNotificationCount()
      },
        60000
    ); //60000
  }
};
</script>
<style scoped>
.is-exact-link {
  color: lime;
}

</style>